import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';

// import { NewRegistrationExistsPage } from '../new-registration-exists/new-registration-exists';
import { NewSubscriptionStep4Page } from '../new-subscription-step4/new-subscription-step4';
import { MainPage } from '../main/main';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { SubscriptionServerProvider } from '../../providers/subscription-server/subscription-server';
import { NewSubscriptionProvider } from '../../providers/new-subscription/new-subscription';
import { EventEmitterProvider } from '../../providers/event-emitter/event-emitter';

import { NewSubscription } from '../../models/newsubscription';
import * as Config from "../../app/app.config";
/**
 * Generated class for the NewSubscriptionStep3Page page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-new-subscription-step3',
  templateUrl: 'new-subscription-step3.html',
})
export class NewSubscriptionStep3Page {

  private user: any;
  public newSubscription: NewSubscription;

  public proofTypeId: number = 0;
  public proofType: string = null;
  public proofFormLetter: string = null;
  public proofFormText:string = null;

  public edited = true;
  public editedCargo = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private subscriptionServerProvider: SubscriptionServerProvider,
    private newSubscriptionProvider: NewSubscriptionProvider,
    private eventEmitterProvider: EventEmitterProvider,
  ) {


    this.proofTypeId = navParams.get('proofTypeId');
    this.proofType = navParams.get('proofType');
    this.proofFormLetter = navParams.get('proofFormLetter');
    this.proofFormText = navParams.get('proofFormText');
    
    if(
        (this.proofTypeId == 3 && this.proofFormLetter == '1') ||
        (this.proofTypeId == 3 && this.proofFormLetter == '2') ||
        (this.proofTypeId == 3 && this.proofFormLetter == '3') ||
        (this.proofTypeId == 4 && this.proofFormLetter == '1') ||
        (this.proofTypeId == 4 && this.proofFormLetter == '2') ||
        (this.proofTypeId == 4 && this.proofFormLetter == '3') ||
        //(this.proofTypeId == 1 && this.proofFormLetter == '3') ||        
        (this.proofTypeId == 1 && this.proofFormLetter == '4')         
      ){

      if( this.proofTypeId == 1 && this.proofFormLetter == '4' ){
        this.editedCargo = false;
      }

      this.edited = false;
    }

    this.newSubscription = new NewSubscription();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewSubscriptionStep3Page');
  }

  ionViewWillEnter() {
    let that = this;

    this.newSubscriptionProvider.load().subscribe((data: any) => {
      if (data) {
        that.newSubscription = data;
      }

      that.loadUserData();
    }, (error: any) => {
      console.log(error);
      that.loadUserData();
    });
  }

  private loadUserData() {
    this.user = this.authProvider.getUser();
    console.log(this.user);

    if (this.validatorProvider.isCnpj(this.user.affiliatedFederalCode)) {
      // if (!this.validatorProvider.isEmpty(this.user.affiliatedFederalCode)) {
      this.newSubscription.affiliatedFederalCode = this.user.affiliatedFederalCode;
    }

    if (this.validatorProvider.isCourseCodeBradesco(this.user.federalCode, this.user.courseCode)) {
      // if (!this.validatorProvider.isEmpty(this.user.courseCode)) {
      this.newSubscription.courseCode = this.user.courseCode;
    }
  }

  onBack() {
    // this.newSubscriptionProvider.saveDataAndGoToPage(this.newSubscription, -1);
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  onNext(nivelId:number, nivelText:string) {
    this.navCtrl.push(NewSubscriptionStep4Page,{

      proofTypeId:this.proofTypeId,
      proofType:this.proofType,
      proofFormLetter:this.proofFormLetter,
      proofFormText:this.proofFormText,
      nivelId:nivelId,
      nivelText:nivelText,
      animation: 'ios-transition'

    });
  }


  doApplyCourseCode() {
    if (this.validatorProvider.isEmpty(this.newSubscription.affiliatedFederalCode)) {
      this.alertProvider.doAlert('Forneça o CNPJ da Empresa.', 'Atenção');
    } else if (!this.validatorProvider.isCnpj(this.newSubscription.affiliatedFederalCode)) {
      this.alertProvider.doAlert('Forneça um CNPJ válido.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.newSubscription.courseCode)) {
      this.alertProvider.doAlert('Forneça o código de curso.', 'Atenção');
    } else if (!this.validatorProvider.isCourseCodeBradesco(this.authProvider.getUser().federalCode, this.newSubscription.courseCode)) {
      this.alertProvider.doAlert('Forneça um código de curso válido.', 'Atenção');
    } else {
      let that = this;

      let loader = this.loadingCtrl.create({
         content: 'Verificando...',
        //duration: 3000
      });
      loader.present();

      this.subscriptionServerProvider.validateFederalCodeAndCourseCodeBradesco(that.newSubscription).subscribe((data: any) => {
        console.log('Retorno da verificacao: ', data);
        loader.dismiss();

        if (data) {
          if (data.result) {
            // Replace user data
            that.user.affiliatedFederalCode = that.newSubscription.affiliatedFederalCode;
            that.user.courseCode = that.newSubscription.courseCode;
            that.authProvider.setUser(that.user);

            that.alertProvider.doAlert('Sua prova foi autorizada.', 'Informe');
            that.navCtrl.setRoot(MainPage);
            that.navCtrl.popToRoot({
              animation: 'ios-transition'
            }, () => {
              that.eventEmitterProvider.get('do_update').emit();
            });
          } else {
            if ((data.code) && (data.code == 2)) {
              that.alertProvider.doAlert('Já existe uma inscrição em andamento com as informações fornecidas.', 'Atenção');
              that.navCtrl.setRoot(MainPage);
              that.navCtrl.popToRoot({
                animation: 'ios-transition'
              }, () => {
                that.eventEmitterProvider.get('do_update').emit();
              });
            } else {
              that.alertProvider.doAlert('Erro na validação do CNPJ e código do curso.', 'Atenção');
            }
          }
        } else {
          that.alertProvider.doAlert('CNPJ não cadastrado.', 'Atenção');
        }
        // TODO: Verify if its true. If true. Come back all to home.
        // TODO: Warn if it is false.
      }, (error: any) => {
        console.log(error);
        loader.dismiss();
        that.alertProvider.doAlert('Erro na validação do CNPJ e código do curso.', 'Atenção');
      });

      // // this.newSubscriptionProvider.doApplyCourseCode(this.newSubscription).subscribe((data: any) => {
      // //   console.log('Retorno da verificacao: ', data);

      // // if ((data == null) || (data.length == 0)) {

      // that.newSubscriptionProvider.saveDataAndGoToPage(that.newSubscription,
      //   NewSubscriptionStep4Page);

      // // } else {

      //   that.navCtrl.push(NewRegistrationExistsPage, {
      //     emails: data
      //   }, {
      //       animation: 'ios-transition'
      //     });

      //   }

      // // }, (error: any) => {
      // //   console.log(error);
      // //   that.newRegistrationProvider.saveDataAndGoToPage(that.newRegistration,
      // //     NewRegistrationStep2Page);
      // // });
    }
  }

  doJump() {
    let that = this;

    this.alertProvider.doConfirm('Ao concordar com essa mensagem você está ciente que uma inscrição para a nova prova será liberada logo após efetuar o pagamento via depósito bancario ou transferência. Você concorda?', () => {
      that.newSubscriptionProvider.saveDataAndGoToPage(that.newSubscription,
        NewSubscriptionStep4Page);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/new-subscription-step3/new-subscription-step3.ts